import { render } from "./AdultLevels.vue?vue&type=template&id=4047adfa&scoped=true"
import script from "./AdultLevels.vue?vue&type=script&lang=js"
export * from "./AdultLevels.vue?vue&type=script&lang=js"

import "./AdultLevels.vue?vue&type=style&index=0&id=4047adfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4047adfa"]])

export default __exports__